import { textos } from '../../textos';
import { Btn } from './Btn';

export function HojaInferior(props: {
  readonly titulo: string;
  readonly onCerrar: () => void;
  readonly children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="fixed inset-0 z-hoja flex flex-col justify-end bg-brand-text/40">
      <button type="button" className="min-h-tactil flex-1" aria-label={textos.acciones.cancelar} onClick={props.onCerrar} />
      <div className="max-h-[80dvh] overflow-auto rounded-t-brand border border-brand-border bg-brand-surface p-4 pb-safe">
        <div className="mb-3 flex items-center justify-between gap-3">
          <h2 className="text-lg font-semibold text-brand-text">{props.titulo}</h2>
          <Btn variante="secundario" onClick={props.onCerrar}>
            {textos.acciones.cancelar}
          </Btn>
        </div>
        {props.children}
      </div>
    </div>
  );
}
